import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IReviewsProductTypeID } from "../../../models/nominals";
import { ISearchFacet } from "../../../models/reviews";
import { ProductTypeFilterSection } from "../ProductTypeFilterSection";
import { RatingFilter } from "../RatingFilter";
import { SourceFilterSection } from "../SourceFilterSection";
import { TextFilter } from "../TextFilter";

export type IProps = Immutable<{
    showProducts: boolean;
    showSources: boolean;
    displayedProductTypeIDWhitelist: readonly IReviewsProductTypeID[];
    maxKeywordsNumber?: number;
    starHasStroke?: boolean;
    isCarouselComponentType?: boolean;
    isCollapsedView?: boolean;
    isCondensedView?: boolean;
}>;

export const Filter = (
    props: { facet: ISearchFacet } & IProps,
): React.JSX.Element | null => {
    switch (props.facet.type) {
        case "text":
            return (
                <TextFilter
                    placeholder={t`SEARCH KEYWORDS`}
                    maxKeywordsNumber={props.maxKeywordsNumber}
                />
            );

        case "rating":
            if (props.isCarouselComponentType) {
                return null;
            }
            return <RatingFilter starHasStroke={props.starHasStroke} />;

        case "product_id":
            if (!props.showProducts) {
                return null;
            }
            return (
                <ProductTypeFilterSection
                    displayedProductTypeIDWhitelist={
                        props.displayedProductTypeIDWhitelist
                    }
                    isCarouselComponentType={props.isCarouselComponentType}
                    isCollapsedView={props.isCollapsedView}
                    isCondensedView={props.isCondensedView}
                />
            );

        case "source_id":
            if (!props.showSources) {
                return null;
            }
            return <SourceFilterSection />;
    }

    return null;
};
